// src/loader.ts
var wasm = null;
var initPromise = null;
async function loadWasm(opts = {}) {
  if (wasm) return wasm;
  if (initPromise) return initPromise;
  initPromise = (async () => {
    const mod = await import("./s1engine_wasm-4XJAWLDD.js");
    const url = opts.wasmUrl ?? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore — wasm-pack output exposes the URL alongside the JS shim
    new URL("../wasm/s1engine_wasm_bg.wasm", import.meta.url);
    await mod.default(url);
    wasm = mod;
    return mod;
  })();
  return initPromise;
}
function _resetForTests() {
  wasm = null;
  initPromise = null;
}

export {
  loadWasm,
  _resetForTests
};
